module.exports = __webpack_public_path__ + "static/codish-d296b1fb279d25aec9e125f895437029.png";